export default __webpack_public_path__ + "523f9989c0cfcac4a26881cdc985bc49.svg";